import { useDispatch, useSelector } from "react-redux";
import BasicCardDocumentos from "../BasicCardDocumentos";
import InputForm from "../InputFormV2";
import { State } from "../../../../reducers";
import { useEffect, useState } from "react";

import DeleteIcon from '../../../../media/felsv/dark_recyclebin_icon.svg'
import EditIcon from '../../../../media/felsv/PenEdit.svg'
import SwitchTipoProductoDTE from "../BasicSwitchTipoProducto";
import { Pagination } from "../../../../components/Pagination";

import PorcentageIcon from '../../../../media/felsv/Porcentaje.svg'
import DolarIcon from '../../../../media/felsv/Dollar.svg'
import useFacturaExportacion from "../../../../actions/factura-exportacion.actions";
import { bindActionCreators } from "redux";
import { actionGeneral, actionsLogin } from "../../../../actions/action-creators";
import OtrosDocAsociados from "../../../EmitirFactura/Components/GeneracionFactura/OtrosDocAsociados";
import DocumentosReceptor from "../../../../components/DocumentoReceptor/DocumentosReceptor";
import { BannerElegirSucursal } from "../../../../components/Banner/BannerElegirSucursal";
import FormaPago from "../FormaPago";
import InputChips from "../InputChips";
import { esCatalogoProductoByTipo } from "../../../../actions/utils-documentos.actions";
import InputSwitchDescripcion, { CheckBoxFlag } from "../InputSwitchDescripcion";

export default function FormulariosFE (){
    const {fecha_actual} = useSelector((state: State) => state.general)
    const {formCliente, errorsCliente, formProducto, errorsProducto, calculosProducto, productos, recintos, regimenes, inconterms, paises, tableProductos} = useSelector((state: State) => state.facturaExportacion)
    const {actividadesEconomicas, datosEmisor, tipoDocumento, tipoPersona, unidadesMedida: unidades, productos: productosCatalogo} = useSelector((state: State) => state.catalogos)
    
    const [customDescripcion, setCustomDescripcion] = useState(false);
    const [checkTextoEnrequecido, setCheckTextoEnrequecido] = useState(false);
    
    const {
        onChangeFormCliente,
        onChangeFormProducto,
        onChangeSelectCatalogoProducto,
        cargarDatosIniciales,
        buscarCliente,

        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,

        validateFormCliente,
        validateFormProducto,

        actionButton_editar,
        actionButton_eliminarProducto,

        cargarSucursales,
        setTableProductos
    } = useFacturaExportacion()
    const dispatch = useDispatch()

    const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)
    const {getFechaHora, validateHorarioSucursal, validateUsoModulo} = bindActionCreators(actionGeneral, dispatch)
    
    const handleChangeFormCliente = (e: any) => {
        onChangeFormCliente(e.target.name, e.target.value)
    }
    const handleChangeFormProducto = (e: any) => {
        onChangeFormProducto(e.target.name, e.target.value)
        if (e.target.name === "descripcion" && e.target.value === "") {setCustomDescripcion(false)}
    }
    const handleSelectCatalogoProducto = (e: any) => {
        if (e.label != -1) onChangeSelectCatalogoProducto(e.value);
        else {
            setCustomDescripcion(true);
            setCheckTextoEnrequecido(false);
            onChangeFormProducto('descripcion', e.value, {clave: ''});
        }
    }
    const handleBlurFormCliente = async(e: any) => {
        validateFormCliente(e.target.name, e.target.value)
        if(e.target.name === 'noDocumento') await buscarCliente()
    }
    const handleBlurFormProducto = (e: any) => {
        validateFormProducto(e.target.name, e.target.value)
    }

    let soloServicios = (productos.length > 0 && productos.some((item) => item.servicio) && !productos.some((item) => !item.servicio))

    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '2'
    let sumaOperaciones = 0
    let seguro = parseFloat(formCliente.seguro || '0')
    let flete = parseFloat(formCliente.flete || '0')
    let descuentoGlobal = parseFloat(formCliente.descuentoGlobal || '0')
    let iva = 0
    let subtotal = 0
    let ivaPercibido = 0
    let ivaRetenido = 0
    let retencionRenta = 0
    let total = 0
    productos.forEach((producto) => {
        let precioUnitario = parseFloat(producto.precio || '0')
        let descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (precioUnitario * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad) : parseFloat(producto.descuento)

        sumaOperaciones += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
    })

    subtotal = sumaOperaciones + seguro + flete
    total = sumaOperaciones + seguro + flete - descuentoGlobal

    useEffect(() => {
        validateUsoModulo()
        validateHorarioSucursal()
        suscripcionGetFacturasDisponibles()
        cargarSucursales()
        cargarDatosIniciales()
        getFechaHora()
    }, [])

    useEffect(() => {
        setTableProductos(productos)
    }, [productos])

    return(
        <>
        <BannerElegirSucursal />
        <div className="otros-documentos-container">
            <div className='dos-columnas-resp'>
            <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
            <BasicCardDocumentos title="Datos del cliente">
                <div className='w-layout-hflex h-inputs'>
                    <InputForm name = 'fecha' placeholder = 'Fecha de emisión' label = 'Fecha' type = 'date' value = {fecha_actual?.FechaInput} error = {errorsCliente.fecha}/>
                    <InputForm required options = {tipoDocumento} keyNameText = 'valor' keyNameValue = 'codigo' name = 'tipoDocumento' placeholder = 'Tipo de documento de identificación' label = 'Tipo de documento de identificación' type = 'select' value = {formCliente.tipoDocumento} error = {errorsCliente.fecha} onChange = {(e: any) => onChangeFormCliente('tipoDocumento', e.value)}/>
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputForm disabled = {!formCliente.tipoDocumento || formCliente.tipoDocumento === ''} onBlur = {handleBlurFormCliente} required name = 'noDocumento' placeholder = {tipoDocumento.find((doc: any) => doc.codigo === formCliente.tipoDocumento && doc.codigo !== '37')?.valor || 'No. Documento de identificación'} label = {tipoDocumento.find((doc: any) => doc.codigo === formCliente.tipoDocumento && doc.codigo !== '37')?.valor || 'No. Documento de identificación'} type = 'text' value = {formCliente.noDocumento} error = {errorsCliente.noDocumento} onChange = {handleChangeFormCliente}/>
                    <InputForm maxLength = {250} onBlur = {handleBlurFormCliente} required name = 'nombre' placeholder = 'Nombre' label = 'Nombre' type = 'text' value = {formCliente.nombre} error = {errorsCliente.nombre} onChange = {handleChangeFormCliente}/>
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputForm options = {tipoPersona} keyNameText = 'valor' keyNameValue = 'codigo' required name = 'persona' label = 'Tipo de persona' type = 'select' value = {formCliente.persona} error = {errorsCliente.persona} onChange = {(e: any) => onChangeFormCliente('persona', e.value)}/>
                    <InputForm options = {paises} keyNameText = 'valor' keyNameValue = 'codigo' required name = 'paisExportacion' label = 'País de exportación' type = 'select' value = {formCliente.paisExportacion} error = {errorsCliente.paisExportacion} onChange = {(e: any) => onChangeFormCliente('paisExportacion', e.value)}/>
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputForm maxLength = {200} onBlur = {handleBlurFormCliente} required name = 'direccion' placeholder = 'Dirección' label = 'Dirección' type = 'text' value = {formCliente.direccion} error = {errorsCliente.direccion} onChange = {handleChangeFormCliente}/>
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputChips maxChips={5} chips={formCliente.chipsEmail} setChips={(chipsEmail: Array<string>) => onChangeFormCliente('chipsEmail', chipsEmail)} maxLength = {100} onBlur = {handleBlurFormCliente} name = 'email' required placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {formCliente.email} error = {errorsCliente.email} onChange = {handleChangeFormCliente}/>
                    {/* <InputForm onBlur = {handleBlurFormCliente} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {formCliente.email} error = {errorsCliente.email} onChange = {handleChangeFormCliente}/> */}
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputForm onBlur = {handleBlurFormCliente} name = 'telefono' placeholder = 'Teléfono celular' label = 'Teléfono celular' type = 'phone' value = {formCliente.telefono} error = {errorsCliente.telefono} onChange = {(phone: any) => onChangeFormCliente('telefono', phone)}/>
                    <InputForm required options = {actividadesEconomicas.map((act) => ({...act, codigo_valor: `${act.codigo}-${act.valor}`}))} keyNameText = 'codigo_valor' keyNameValue = 'codigo' name = 'actividad' placeholder = 'Actividad económica' label = 'Actividad económica' type = 'select' value = {formCliente.actividad} error = {errorsCliente.actividad} onChange = {(e: any) => onChangeFormCliente('actividad', e.value)}/>
                </div>  
                {/* <div>
                    <h3 className="card-title">Condición de la operación</h3>
                </div>
                <hr className="separador"/> 
                <InputForm options = {condicionOperacion} keyNameText = 'valor' keyNameValue = 'codigo' name = 'condicion' label = 'Condición' type = 'select' value = {formCliente.condicion} error = {errorsCliente.condicion} onChange = {(e: any) => onChangeFormCliente('condicion', e.value)}/> */}
            </BasicCardDocumentos>
            </div>
            <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
            <BasicCardDocumentos title="Sucursal y serie">
                <div className='w-layout-hflex h-inputs'>
                    <InputForm disabled={true} required options = {formCliente?.datosSucursal} keyNameText = 'nombre' keyNameValue = 'idsucursal' name = 'sucursal' placeholder = 'Sucursal' label = 'Sucursal' type = 'select' value = {formCliente.sucursal} error = {errorsCliente.sucursal} onChange = {(e: any) => onChangeFormCliente('sucursal', e.value)}/>
                    <InputForm disabled={!formCliente.loadedSucursal} required options = {formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente?.sucursal)?.Documento?.map((doc: any) => ({...doc, serie_numero: `${doc.serie}-${doc.numeroactual}`}))} keyNameText = 'serie_numero' keyNameValue = 'idsucursaldocumento' name = 'serie' placeholder = 'Serie' label = 'Serie' type = 'select' value = {formCliente.serie} error = {errorsCliente.serie} onChange = {(e: any) => onChangeFormCliente('serie', e.value)}/>
                </div>
                <div>
                    <h3 className="card-title">Datos de exportación</h3>
                </div>
                <hr className="separador"/>
                    {!soloServicios &&
                        <div className='w-layout-hflex h-inputs'>
                            <InputForm options = {recintos} keyNameText = 'valor' keyNameValue = 'codigo'  label = 'Recinto fiscal' type = 'select' value = {formCliente.recintoFiscal} error = {errorsCliente.recintoFiscal} onChange = {(e: any) => onChangeFormCliente('recintoFiscal', e.value)}/>
                            <InputForm options = {regimenes} keyNameText = 'valor' keyNameValue = 'codigo'  label = 'Régimen de exportación' type = 'select' value = {formCliente.regimenExportacion} error = {errorsCliente.regimenExportacion} onChange = {(e: any) => onChangeFormCliente('regimenExportacion', e.value)}/>
                        </div>
                    }
                <div className='w-layout-hflex h-inputs'>
                    <InputForm options = {inconterms} keyNameText = 'valor' keyNameValue = 'codigo'  label = 'INCOTERMS' type = 'select' value = {formCliente.incoterms} error = {errorsCliente.incoterms} onChange = {(e: any) => onChangeFormCliente('incoterms', e.value)}/>
                    <InputForm leftIcon = {DolarIcon} maxLength = {50} onBlur = {handleBlurFormCliente} name = 'seguro' placeholder = '$0.00' label = 'Seguro' type = 'text' value = {formCliente.seguro} error = {errorsCliente.seguro} onChange = {handleChangeFormCliente}/>
                </div>
                <div className='w-layout-hflex h-inputs'>
                    <InputForm leftIcon = {DolarIcon} maxLength = {50} onBlur = {handleBlurFormCliente} name = 'flete' placeholder = '$0.00' label = 'Flete' type = 'text' value = {formCliente.flete} error = {errorsCliente.flete} onChange = {handleChangeFormCliente}/>
                    <InputForm leftIcon = {DolarIcon}  maxLength = {50} onBlur = {handleBlurFormCliente} name = 'descuentoGlobal' placeholder = '$0.00' label = 'Descuento global' type = 'text' value = {formCliente.descuentoGlobal} error = {errorsCliente.descuentoGlobal} onChange = {handleChangeFormCliente}/>
                </div>
            </BasicCardDocumentos>
            </div>
            </div>
            <div className="w-layout-layout bill-section wf-layout-layout">
            <BasicCardDocumentos title="Agregar producto o servicio">
            <SwitchTipoProductoDTE producto = {!formProducto.servicio} setProducto = {() => onChangeFormProducto('servicio', false)} setServicio = {() => onChangeFormProducto('servicio', true)}/>
            
            {
                (!customDescripcion && productosCatalogo.length > 0)
                ? 
                    <InputForm 
                        enableCreate={true} required 
                        label = 'Descripción' type = 'select' 
                        options = {productosCatalogo.filter((prod) => esCatalogoProductoByTipo(formProducto.servicio, prod))} 
                        keyNameText = 'descripcion' keyNameValue = 'clave' 
                        onChange = {handleSelectCatalogoProducto} 
                        value = {formProducto.clave} error = {errorsProducto.descripcion}
                        componentSideLabel = {
                            <CheckBoxFlag
                              label="Activar texto con formato" 
                              value={customDescripcion} 
                              onChange={() => {
                                setCustomDescripcion(true);
                                setCheckTextoEnrequecido(true);
                              }}
                            />
                        }
                    />
                : (
                    <div className="w-layout-hflex h-inputs">
                        <InputSwitchDescripcion defaultEnrequecido={checkTextoEnrequecido} className='m text-field w-input' maxLength = {1000} onBlur = {handleBlurFormProducto} required name = 'descripcion' placeholder = 'Descripción' label = 'Descripción' type = 'text' value = {formProducto.descripcion} error = {errorsProducto.descripcion} onChange = {handleChangeFormProducto}/>    
                    </div>
                )
            }
            
            <div className='w-layout-hflex h-inputs'>
            <InputForm maxLength = {15} onBlur = {handleBlurFormProducto} required name = 'cantidad' placeholder = '0' label = 'Cantidad' type = 'text' value = {formProducto.cantidad} error = {errorsProducto.cantidad} onChange = {handleChangeFormProducto}/>
            <InputForm options = {unidades} keyNameText = 'valor' keyNameValue = 'codigo' name = 'unidad' label = 'Unidad de medida' type = 'select' value = {formProducto.unidadMedida} error = {errorsProducto.unidadMedida} onChange = {(e: any) => onChangeFormProducto('unidadMedida', e.value)}/>
            <InputForm maxLength = {15} onBlur = {handleBlurFormProducto} required name = 'precio' placeholder = '$0.00' label = 'Precio' type = 'text' value = {formProducto.precio} error = {errorsProducto.precio} onChange = {handleChangeFormProducto}/>
            <InputForm options = {[{nombre: 'Porcentaje'}, {nombre: 'Monto'}]} keyNameText = 'nombre' keyNameValue = 'nombre' name = 'tipoDescuento' placeholder = 'Tipo de descuento' label = 'Tipo de desc.' type = 'select' value = {formProducto.tipoDescuento} error = {null} onChange = {(e: any) => onChangeFormProducto('tipoDescuento', e.value)}/>
            <InputForm 
                    maxLength = {formProducto.tipoDescuento === 'Porcentaje' ? 6 : 15}
                    leftIcon = {formProducto.tipoDescuento === 'Porcentaje' ? PorcentageIcon : DolarIcon}
                    type = 'text'
                    value = {formProducto.descuento}
                    name = 'descuento'
                    onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                    placeholder = '0.00'
                    label = 'Descuento'
                    error = {errorsProducto.descuento}
                />
            </div>
            <div className="cf-calculos-producto">
                <table>
                    <tbody>
                        <tr className="cf-subtotal">
                            <td>Subtotal</td>
                            <td>{calculosProducto?.neto}</td>
                        </tr>
                        <tr className="cf-descuento">
                            <td>Descuento</td>
                            <td>{calculosProducto?.descuento}</td>
                        </tr>
                        <tr className="cf-total">
                            <td>Total</td>
                            <td>{calculosProducto?.total}</td>
                        </tr>
                    </tbody>
                </table>
                <div className="w-layout-hflex button-actions">
                    <button className="button transparent" onClick={() => {button_onClickLimpiarFormProducto(); setCustomDescripcion(false)}}>Limpiar</button>
                    <button className="button" onClick={() => {button_onClickAgregarProducto(); setCustomDescripcion(false)}}>Agregar</button>
                </div>
            </div>
            </BasicCardDocumentos>
            </div>
            <div className="w-100">
            <div className="w-layout-layout bill-section wf-layout-layout">
            <BasicCardDocumentos title="Detalle de productos o servicios" style={{ maxWidth: "100%", boxShadow: "none" }}>
                <div className="tab-plane">
                    <div className="table-facturacion-resp">
                    <table className="table-main-responsive responsive-table-main td-left table-pointer">
                        <thead>
                            <tr>
                                <td>Cantidad</td>
                                <td>Unidad de medida</td>
                                <td>Tipo</td>
                                <td>Descripción</td>
                                <td>Precio unitario</td>
                                <td>Descuento</td>
                                <td>Ventas gravadas</td>
                                <td>Acciones</td>
                            </tr>
                        </thead>
                        <tbody>
                            {tableProductos.map((producto, index) => {
                                let precioUnitario = 0
                                let descuento = 0
                                let gravadas = 0
                                let exentas = 0
                                
                                precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                                descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (parseFloat(producto.descuento)/100*precioUnitario) * parseFloat(producto.cantidad) : parseFloat(producto.descuento) 
                                gravadas = (precioUnitario * parseFloat(producto.cantidad)) - descuento
                                exentas = (precioUnitario * parseFloat(producto.cantidad)) - descuento  

                                return(
                                <tr key={index}>
                                    <td data-label="Cantidad">{producto.cantidad}</td>
                                    <td data-label="Unidad de medida">{unidades.find((unidad: any) => unidad.codigo === producto.unidadMedida)?.valor}</td>
                                    <td data-label="Tipo">{`${producto.servicio ? 'Servicio' : 'Producto'} ${producto.exento ? ' exento' : ''}`}</td>
                                    <td data-label="Descripción" style={{wordBreak:"break-all"}}>{<div dangerouslySetInnerHTML={{ __html: producto.descripcion }} />}</td>
                                    <td data-label="Precio unitario">{precioUnitario.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    <td data-label="Descuento">{isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                    <td data-label="Ventas gravadas">{!producto.exento ? (isNaN(gravadas) ? '$0.00' : gravadas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})): '$0.00'}</td>
                                    <td data-label="Acciones">
                                        <button onClick={() => actionButton_editar(producto, index)}><img src={EditIcon}/></button>
                                        <button onClick={() => actionButton_eliminarProducto(producto.id)}><img src={DeleteIcon}/></button>
                                    </td>
                                </tr>
                            )})}
                        </tbody>
                    </table>
                    <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                    <div className="cf-calculos-producto">
                        <table>
                            <tbody>
                                <tr className="cf-subtotal">
                                    <td>Suma de operaciones</td>
                                    <td>{sumaOperaciones.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Seguro</td>
                                    <td>{seguro.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Flete</td>
                                    <td>{flete.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Subtotal</td>
                                    <td>{subtotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-subtotal">
                                    <td>Descuento global</td>
                                    <td>{descuentoGlobal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                                <tr className="cf-total">
                                    <td>Total</td>
                                    <td>{total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </div>
                </div>
                <FormaPago totalAPagar={total.toString()}/>
            </BasicCardDocumentos>
            </div>
            </div>
            <div className="w-layout-layout bill-section wf-layout-layout">
                <OtrosDocAsociados />
                <DocumentosReceptor />
            </div>
        </div>
        </>
    )
}